import {
  IValidationResult,
  IValidator,
  IDeferred,
  IPromise,
  Stop,
  IObserver,
} from '@admin/shared/validation/validators';

export interface IFieldValidationSet {
  items: IValidationResult[];
  isCompleted: boolean;
}

export interface IValidationResultSet {
  isValid: boolean;
  set: { [field: number]: IFieldValidationSet };
}

export class ValidationContainer {
  public static attachValidationResult(
    results: IValidationResultSet,
    item: IValidationResult,
    validator: IValidator
  ) {
    var scope = validator.scope;
    var isStop = validator.isStop;

    if (results.set[scope.fieldId] == null)
      results.set[scope.fieldId] = { items: [], isCompleted: false };
    var set = results.set[scope.fieldId];

    if (!item.isValid) {
      results.isValid = false;
      if (!isStop && !set.isCompleted) set.items.push(item);
    }
    if (!item.isValid || isStop) set.isCompleted = true;
  }

  private static isScopeCompleted(
    results: IValidationResultSet,
    validator: IValidator
  ) {
    var set = results.set[validator.scope.fieldId];
    return set != null && set.isCompleted;
  }

  static validate(
    validators: IValidator[],
    observer: IObserver,
    results: IValidationResultSet
  ): void {
    var asyncStarted = false;
    var promiseLink = null;

    for (var i = 0; i < validators.length; i++) {
      var item = validators[i];

      if (item.isAsync) {
        if (!this.isScopeCompleted(results, item)) {
          asyncStarted = true;

          if (promiseLink == null) promiseLink = item.promiser();

          promiseLink = promiseLink.then(
            ((ix: number) => (response) => {
              var current = validators[ix];
              if (current.isAsync && !this.isScopeCompleted(results, current)) {
                // console.log("async validator at: " + ix);
                var asyncResult = current.asyncValidator(response);
                this.attachValidationResult(results, asyncResult, current);
              }
              var localIndex = ix + 1;
              if (localIndex == validators.length) {
                observer.destination.complete();
                return;
              }
              var next = validators[localIndex];
              var resultPromise = null;
              if (next.isAsync) {
                var nextPromise = next.promiser();
                resultPromise = nextPromise;
              } else {
                var hasNext = true;
                while (true) {
                  // console.log("sync validator at: " + localIndex);
                  if (!this.isScopeCompleted(results, next)) {
                    var result = next.syncValidator();

                    this.attachValidationResult(results, result, next);
                  }
                  if (localIndex == validators.length - 1) {
                    hasNext = false;
                    break;
                  }
                  next = validators[localIndex + 1];
                  if (!next.isAsync) localIndex++;
                  else break;
                }
                if (hasNext) return next.promiser();
              }

              if (localIndex === validators.length - 1) {
                observer.destination.complete();
              }
              return resultPromise;
            })(i)
          );
        }
      } else if (!asyncStarted) {
        // console.log("sync validator at: " + i);
        if (!this.isScopeCompleted(results, item)) {
          var result = item.syncValidator();
          observer.destination.next(item);
        }
      }
    }
    if (!asyncStarted) observer.destination.complete();
  }
}
